// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e716c90a] .modal-footer{display:-webkit-box;display:-ms-flexbox;display:flex}[data-v-e716c90a] .modal-footer .gap{-webkit-box-flex:1;-ms-flex:1;flex:1}.btnsplit[data-v-e716c90a]{width:80px}.btnsplit.noclick[data-v-e716c90a]{cursor:not-allowed}", ""]);
// Exports
module.exports = exports;
